export class CreateDataCatalogInput {
    'connectorId';
    'name';
    'catalogType';
    'glueProperties';
    'biglakeProperties';
    'icebergRestProperties';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "connectorId",
            "baseName": "connectorId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogType",
            "baseName": "catalogType",
            "type": "DataCatalogType",
            "format": ""
        },
        {
            "name": "glueProperties",
            "baseName": "glueProperties",
            "type": "DataCatalogGlueProperties",
            "format": ""
        },
        {
            "name": "biglakeProperties",
            "baseName": "biglakeProperties",
            "type": "DataCatalogBiglakeProperties",
            "format": ""
        },
        {
            "name": "icebergRestProperties",
            "baseName": "icebergRestProperties",
            "type": "DataCatalogIcebergRestProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDataCatalogInput.attributeTypeMap;
    }
    constructor() {
    }
}
